import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Icon, Text, ToggleIcon } from '../../atoms';
import { AvatarName } from '../../molecules';

import theme from '../../../styles/theme';
import { useUserContext } from '../../../contexts/UserContext';
import { usePostContext } from '../../../contexts/PostContext';
import { postAPI } from '../../../service/api';

const QuestionerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${theme.spacing.l};
  color: ${theme.colors.gray600};
  padding: 0 2px;
`;

const PostContainer = styled.article`
  border-radius: 12px;
  padding: 30px 28px;
  background-color: white;
  box-shadow: ${theme.surface.boxShadow};
  margin-top: ${theme.spacing.m};
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 220px;
  padding: 0 20px;
  box-sizing: border-box;
  border-radius: ${theme.surface.borderRadius};
  margin-bottom: ${theme.spacing.xs};
  font-size: ${theme.fontSizes.lg};
  ${theme.mediaQuery('tablet')} {
    font-size: ${theme.fontSizes.md};
  }
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.xs};
`;

const Comment = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.xxs};
`;

const QuestionItem = ({ post }) => {
  const {
    user: { id: userId },
  } = useUserContext();

  const { handleDeleteLike, handleCreateLike } = usePostContext();
  const { id, author, title, likes, comments } = post;

  const [on, setOn] = useState(false);

  const handleClick = useCallback(async () => {
    if (on) {
      const index = likes.findIndex(({ user }) => user === userId);
      if (index === -1) return;
      const likeId = likes[index]._id;

      await postAPI.deleteLikedPost(likeId);
      handleDeleteLike({ userId, postId: id });

      setOn(false);
    } else {
      const createdLike = await postAPI.createLikedPost(id);
      handleCreateLike({ postId: id, createdLike });
      setOn(true);
    }
  }, [id, likes, userId, on, handleDeleteLike, handleCreateLike]);

  useEffect(() => {
    if (likes) {
      setOn(likes.some(({ user }) => user === userId));
    }
  }, [likes, userId]);

  return (
    <Link to={`/question/${id}`} style={{ textDecoration: 'none' }}>
      <PostContainer key={id}>
        <Content>
          <Text style={{ fontSize: 'inherit' }}>{title}</Text>
        </Content>
        <QuestionerContainer>
          <AvatarName
            size="base"
            username={author?.username}
            src="https://picsum.photos/200?random=1"
          />

          <Actions>
            <ToggleIcon on={on} name="heart" size={24} onChange={handleClick} />
            <Comment>
              <Icon
                name="message-circle"
                size={24}
                color={theme.colors.gray500}
                style={{ transform: 'scaleX(-1)' }}
              />
              <Text block={false} size="xs" color={theme.colors.gray500}>
                {comments?.length}
              </Text>
            </Comment>
          </Actions>
        </QuestionerContainer>
      </PostContainer>
    </Link>
  );
};

QuestionItem.propTypes = {
  post: PropTypes.object.isRequired,
};

export default QuestionItem;
